import { Formik, Form } from 'formik';
import React, { useEffect, useState } from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import axios from '../../util/Api';
import { Button, Card, Input, message, Switch } from 'antd';
import BroadcastConsumer from '../Support/BroadcastConsumer';

const Manage = () => {
  const [loading, setLoading] = useState(true);
  const [broadcast, setBroadcast] = useState({});
  const [preview, setPreview] = useState(false);

  useEffect(() => {
    getBroadcast();
  }, []);

  const getBroadcast = () => {
    setLoading(true);
    const url = `/broadcast/detail`;
    axios.get(url).then(resp => {
      setBroadcast(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Broadcast message gagal diperbarui");
    });
  }

  const br2nl = (str, replaceMode) => {   

    var replaceStr = (replaceMode) ? "\n" : '';
    // Includes <br>, <BR>, <br />, </br>
    return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
  }

  return (
    <Auxiliary>
      <Title>Kelola Broadcast</Title>

      {preview ? <BroadcastConsumer onClose={() => setPreview(false)} /> : null}

      {loading ? "Sedang memuat..." : (
        <Card className="gx-card">
          
          <Formik
            initialValues={{
              content: br2nl(broadcast.content, false),
              is_active: broadcast.is_active
            }}
            onSubmit={values => {
              const url = `/broadcast/update`;
              axios.post(url, { ...values }).then(resp => {
                setBroadcast(resp.data);
                message.success("Broadcast message telah berhasil diperbarui");
              }).catch(err => {
                message.error("Gagal memperbarui broadcast");
              });
            }}
          >
            {(formik) => {
              return (
                <Form>
                  <div className="gx-mb-3">
                    <label htmlFor="content" className="gx-mb-1">Konten</label>
                    <Input.TextArea rows={10} name="content" onChange={formik.handleChange} value={formik.values.content} />
                  </div>

                  <div className="gx-mb-3">
                    <label htmlFor="content" className="gx-mb-1 gx-mr-3">Tampilkan</label>
                    <Switch checkedChildren="Ditampilkan" unCheckedChildren="Tidak Ditampilkan" defaultChecked={formik.values.is_active} onChange={(e) => formik.setFieldValue("is_active", e)} />
                  </div>

                  <div className="gx-mt-5">
                    <Button type="primary" htmlType="submit">Simpan Perubahan</Button>
                    <Button type="default" htmlType="button" onClick={() => setPreview(true)}>
                      {preview ? `Tutup Preview` : `Preview Broadcast`}
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Card>
      )}

    </Auxiliary>
  );
}

export default Manage;